import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

@Component({
  selector: "app-my-error-state-matcher",
  templateUrl: "./my-error-state-matcher.component.html",
  styleUrls: ["./my-error-state-matcher.component.css"],
})
export class MyErrorStateMatcherComponent implements OnInit, ErrorStateMatcher {
  constructor() {}
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
    // throw new Error('Method not implemented.');
  }

  ngOnInit(): void {}
}
